/*
 *
 * CoursesDetail reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_COURSE,
  LOAD_COURSE_SUCCESS,
  LOAD_COURSE_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  itemData: false,
  id: false,
};

/* eslint-disable default-case, no-param-reassign */
const coursesDetailReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      // Load
      case LOAD_COURSE:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_COURSE_SUCCESS:
        draft.itemData = action.itemData;
        draft.loading = false;
        draft.firstRender = false;
        break;

      case LOAD_COURSE_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;
      
    }
  });

export default coursesDetailReducer;
